class Header {
  constructor() {
    this.header = document.querySelector('[data-section-type="header"]');
    this.cartCountElements = document.querySelectorAll('.header__cart-link-count');
    
    this.cartDrawer = document.querySelector('[data-cart-drawer]') || 
                      document.querySelector('#cart-drawer') ||
                      document.querySelector('.cart-drawer') ||
                      document.querySelector('[data-section-type="cart-drawer"]') ||
                      document.querySelector('[data-drawer="cart"]');
                      
    this.previousCount = window.cartCount || 0;
    this.init();
    this.startCartPolling();
  }

  init() {
    this.setHeaderHeight();
    this.setupCartCountObserver();
  }

  setHeaderHeight() {
    if (this.header) {
      document.documentElement.style.setProperty('--height-header', this.header.offsetHeight + 'px');
    }
  }

  startCartPolling() {
    setInterval(async () => {
      try {
        const response = await fetch('/cart.js');
        const cartData = await response.json();
        
        if (cartData.item_count !== this.previousCount) {
          this.previousCount = cartData.item_count;
          
          this.cartCountElements.forEach(element => {
            element.textContent = cartData.item_count;
          });

          if (!this.cartDrawer) {
            this.cartDrawer = document.querySelector('[data-cart-drawer]') || 
                             document.querySelector('#cart-drawer') ||
                             document.querySelector('.cart-drawer') ||
                             document.querySelector('[data-section-type="cart-drawer"]') ||
                             document.querySelector('[data-drawer="cart"]');
          }

          this.openCartDrawer();
        }
      } catch (error) {}
    }, 1000);
  }

  setupCartCountObserver() {
    if (!this.cartCountElements.length) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          const newCount = parseInt(mutation.target.textContent || mutation.target.innerText);
          if (!isNaN(newCount) && newCount !== this.previousCount) {
            this.previousCount = newCount;
            this.openCartDrawer();
          }
        }
      });
    });

    this.cartCountElements.forEach((element, index) => {
      observer.observe(element, {
        characterData: true,
        childList: true,
        subtree: true
      });
    });
  }

  openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    
    if (this.cartDrawer) {
      this.cartDrawer.classList.add('is-open', 'is-active', 'is-visible', 'drawer--is-open');
      document.body.classList.add('cart-drawer-open', 'drawer-open');
    }

    const cartButtons = [
      document.querySelector('[data-cart-drawer-button]'),
      document.querySelector('[data-cart-toggle]'),
      document.querySelector('[data-cart-trigger]'),
      document.querySelector('.header__cart-link'),
      document.querySelector('a[href="/cart"]')
    ];

    const cartButton = cartButtons.find(button => button);
    if (cartButton) {
      cartButton.click();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Header();
});